import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import styles from '../Steps.module.scss';
import 'react-quill/dist/quill.snow.css';
import { API_URL, securityHeaders } from '../../../../Constants';
import { FormikProvider, useFormik } from 'formik';
import getValidationSchemaStep3 from '../ValidationSchema/Step3ValidationSchema';
import TextEditor from '../../Email/TextEditor';
import { useMutation } from 'react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../Custom/CustomToaster/Toast';
import he from 'he';

const ProgramThirdStep = forwardRef(({ id, degree, mode }, ref) => {
  const [init, setInit] = useState({});
  const customizedToast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const initialvalues = {
      DegreeId:
        degree?.degree?.degreeId || '00000000-0000-0000-0000-000000000000',

      AdmissionRequirementsAr: he.decode(
        degree?.degree?.admissionRequirementsAr || ''
      ),

      AddmissionDocumentsAr: he.decode(
        degree?.degree?.addmissionDocumentsAr ??
          degree?.degree?.admissionDocumentsAr ??
          ''
      ),
    };

    setInit(initialvalues);
  }, [degree]);

  const handleStep3Submit = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Degree/Stage3Degree`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      customizedToast.open('تم حفظ البرنامج');
      navigate('/home/programs');
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const formik = useFormik({
    initialValues: init,
    validationSchema: getValidationSchemaStep3(),
    enableReinitialize: true,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append('DegreeId', values.DegreeId);

      formData.append(
        'AdmissionRequirementsAr',
        values.AdmissionRequirementsAr
      );

      formData.append('AddmissionDocumentsAr', values.AddmissionDocumentsAr);

      handleStep3Submit.mutate(formData);
    },
  });

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      formik.submitForm();
    },
  }));

  useEffect(() => {
    ref.current = formik;
  }, [ref, formik]);

  return (
    <div>
      <FormikProvider value={formik} innerRef={ref}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          {' '}
          <div className={`${styles['quill-container']} ${styles['rtl']}`}>
            <TextEditor
              label='الوثائق المطلوبة'
              name='AddmissionDocumentsAr'
              value={formik.values.AddmissionDocumentsAr}
              onChange={(name, value) => formik.setFieldValue(name, value)}
              errors={formik.errors.AddmissionDocumentsAr}
              touched={formik.touched.AddmissionDocumentsAr}
              right
            />
          </div>
          <div className={`${styles['quill-container']} ${styles['rtl']}`}>
            <TextEditor
              label='شروط القبول'
              name='AdmissionRequirementsAr'
              value={formik.values.AdmissionRequirementsAr}
              onChange={(name, value) => formik.setFieldValue(name, value)}
              errors={formik.errors.AdmissionRequirementsAr}
              touched={formik.touched.AdmissionRequirementsAr}
              right
            />
          </div>
        </div>
      </FormikProvider>
    </div>
  );
});

export default ProgramThirdStep;
